var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordcloud-container",style:({ width: _vm.containerWidth, height: _vm.containerHeight })},[_c('VueWordCloud',{staticClass:"wordcloud",attrs:{"words":_vm.formattedWords,"spacing":0.4,"font-size-ratio":Number(5),"font-weight":([, weight]) =>
      weight >= _vm.wordWeightGroupBoundaries[0] ? '900'
      : weight >= _vm.wordWeightGroupBoundaries[1] ? '700'
      : weight >= _vm.wordWeightGroupBoundaries[2] ? '600'
      : weight >= _vm.wordWeightGroupBoundaries[3] ? '400'
      : '400',"color":([, weight]) =>
      weight >= _vm.wordWeightGroupBoundaries[0] ? '#172542'
      : weight >= _vm.wordWeightGroupBoundaries[1] ? '#98c1dd'
      : weight >= _vm.wordWeightGroupBoundaries[2] ? '#172542'
      : weight >= _vm.wordWeightGroupBoundaries[3] ? '#98c1dd'
      : '#172542',"font-family":"Montserrat"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }